
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";

import { Head } from "@/components/Head";
import { ContentSection } from "@/sections/ContentSection";

const Legal = () => {
  return (
    <>
      <Head pageNamespace="page/legal" ogImage="/images/main-og-image.jpg" />
      <ContentSection title="Legal">
        <h2>General Information</h2>
        <p>Magicul</p>
        <p>
          Contact Details:
          <br />
          Email: support@magicul.io
          <br />
          Web: https://magicul.io
        </p>
        <br />
        <h2>Liability for Contents</h2>
        <p>
          As service providers, we are liable for own contents of these
          websites. However service providers are not obligated to permanently
          monitor submitted or stored information or to search for evidences
          that indicate illegal activities. Legal obligations to removing
          information or to blocking the use of information remain unchallenged.
          In this case, liability is only possible at the time of knowledge
          about a specific violation of law. Illegal contents will be removed
          immediately at the time we get knowledge of them.
        </p>
        <p>
          Legal obligations to removing information or to blocking the use of
          information remain unchallenged. In this case, liability is only
          possible at the time of knowledge about a specific violation of law.
          Illegal contents will be removed immediately at the time we get
          knowledge of them.
        </p>
        <h2>Liability for Links</h2>
        <p>
          Our offer includes links to external third party websites. We have no
          influence on the contents of those websites, therefore we cannot
          guarantee for those contents. Providers or administrators of linked
          websites are always responsible for their own contents.
        </p>
        <p>
          The linked websites had been checked for possible violations of law at
          the time of the establishment of the link. Illegal contents were not
          detected at the time of linking. A permanent monitoring of the
          contents of linked websites cannot be imposed without reasonable
          indications that there has been a violation of law. Illegal links will
          be removed immediately at the time we get knowledge of them.
        </p>
        <h2>Copyright</h2>
        <p>
          Contents and compilations published on these websites by the providers
          are subject to U.S. copyright laws. Reproduction, editing,
          distribution as well as the use of any kind outside the scope of the
          copyright law require a written permission of the author or
          originator. Downloads and copies of these websites are permitted for
          private use only. The commercial use of our content without permission
          of the originator is prohibited.
        </p>
        <p>
          Copyright laws of third parties are respected as long as the contents
          on these websites do not originate from the provider. Contributions of
          third parties on this site are indicated as such. However, if you
          notice any violations of copyright law, please inform us. Such
          contents will be removed immediately.
        </p>
        <h2>Changes to the Terms of Service and the Website</h2>
        <p>
          Magicul is a work in progress, meaning that a lot will change in the
          near future. We reserve the right to update the Website, the apps and
          these Terms of Service from time to time, at our discretion. We will
          make sure to announce any major change in a prominent way, but since
          “major” is a very subjective concept. Your continued use of the
          Website following the publishing of updated Terms of Service means
          that you accept and agree to the changes.
        </p>
      </ContentSection>
    </>
  );
};

export default Legal;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/legal',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  